import { connect } from "react-redux";
import RankingTable from "../../Ranking/RankingTable.jsx";
import { openTeamDetails } from "../../TeamDetails/teamDetailsActions";
import { markTeamSportsmen } from "../../Results/MarkedSportsen/markSportsmenActions";

const mapStateToProps = (state, ownProps) => {
  let markedTeams = [];
  let entries;

  if (ownProps.displayRanked) {
    entries = state.subleagues.entries.filter((item) => item.ranked);
  } else {
    entries = state.subleagues.entries;
  }

  if (state.ranking.entriesOwn) {
    markedTeams = state.ranking.entriesOwn.map((e) => e.zweelerTeamId);
  }

  return {
    entries,
    columns: state.subleagues.entriesColumns,
    game: state.games.current,
    userEntries: null,
    markedTeams: markedTeams,
  };
};

const mapDispatchToProps = (dispatch, { classificationId }) => {
  return {
    onDetailsClick: (teamId) =>
      dispatch(markTeamSportsmen(teamId, classificationId)),
    onTeamClick: (teamId) => dispatch(openTeamDetails(teamId)),
  };
};

const RankingTableContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(RankingTable);

export default RankingTableContainer;
